import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CommonButton from 'app/components/ReviewButton';
import { decodeURL, encodeURL } from 'app/utils/helpers';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { TRANSLATION_KEYS } from '@/app/constants/transalations';

import { ViewSegregateImagesButtonProps } from '../types';
import { DataCompositionModal } from './DataCompositionModal';

export const ViewSegregateImagesButton = ({
  segregateKwargs,
  dataComposition,
}: ViewSegregateImagesButtonProps) => {
  const [isDataCompositionModalOpen, setIsDataCompositionModalOpen] =
    useState(false);
  const { t } = useTranslation(TRANSLATION_KEYS.REVIEW);
  const { subscriptionId, packId } = useParams<{
    subscriptionId: string;
    packId: string;
  }>();

  const handleViewImages = () => {
    const tags = [
      segregateKwargs?.fileset_train_tag_id,
      segregateKwargs?.fileset_test_tag_id,
    ].filter(Boolean);
    const decodedFileSetFilters = decodeURL(segregateKwargs?.file_set_filters);
    const contextualFilters = encodeURL({
      ...decodedFileSetFilters,
      tags__in: tags,
    });
    window.open(
      `/${subscriptionId}/${packId}/annotation/review?contextual_filters=${contextualFilters}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  const showViewImages =
    segregateKwargs &&
    !!segregateKwargs.fileset_train_tag_id &&
    !!segregateKwargs.fileset_test_tag_id &&
    !!segregateKwargs.file_set_filters;

  const showDataComposition =
    dataComposition &&
    Object.keys(dataComposition.train_counts).length > 0 &&
    Object.keys(dataComposition.test_counts).length > 0;

  return (
    <>
      {showViewImages && (
        <CommonButton
          text={t('View images')}
          onClick={handleViewImages}
          variant='tertiary'
          icon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
        />
      )}
      {showDataComposition && (
        <CommonButton
          text={t('Data Composition')}
          onClick={() => setIsDataCompositionModalOpen(true)}
          variant='tertiary'
        />
      )}
      {showDataComposition && (
        <DataCompositionModal
          isDataCompositionModalOpen={isDataCompositionModalOpen}
          onClose={() => setIsDataCompositionModalOpen(false)}
          test_counts={dataComposition!.test_counts}
          train_counts={dataComposition!.train_counts}
        />
      )}
    </>
  );
};
